module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#fff",
      "padding": "20px"
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-width": "108px",
      "model": _vm.formData,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "username"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入用户名",
      "clearable": ""
    },
    model: {
      value: (_vm.formData.username),
      callback: function($$v) {
        _vm.$set(_vm.formData, "username", $$v)
      },
      expression: "formData.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "pass"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "placeholder": "请输入密码",
      "clearable": ""
    },
    model: {
      value: (_vm.formData.pass),
      callback: function($$v) {
        _vm.$set(_vm.formData, "pass", $$v)
      },
      expression: "formData.pass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "重复密码",
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "placeholder": "请输入密码",
      "clearable": ""
    },
    model: {
      value: (_vm.formData.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.formData, "checkPass", $$v)
      },
      expression: "formData.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "phone"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "placeholder": "请输入中国大陆手机号",
      "clearable": ""
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", _vm._n($$v))
      },
      expression: "formData.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "验证码",
      "prop": "code"
    }
  }, [_c('el-input', {
    staticClass: "inputidecode",
    staticStyle: {
      "width": "150px",
      "height": "34px"
    },
    attrs: {
      "placeholder": "请输入验证码",
      "clearable": ""
    },
    model: {
      value: (_vm.formData.code),
      callback: function($$v) {
        _vm.$set(_vm.formData, "code", _vm._n($$v))
      },
      expression: "formData.code"
    }
  }), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.getidecodeFun
    }
  }, [_vm._v(_vm._s(_vm.getidecodeData))])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-foot-bar fixed-footer-bar"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('ruleForm')
      }
    }
  }, [_vm._v("还原")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28d8d52c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/mine/UpdataInfo.vue
// module id = 1177
// module chunks = 0